const routesName = {
  cmpHomePage: "",
  forgotPasswordPage: "/forgot-password",
  loginDashboardPage: "/dashBoard",
  managementInfoSystemPage: "/mis",
  hospitalManagementPage: "/hospital-management",
  accountManagerPage: "/account-manager",
  notificationPage: "/notifications",
  devicesPage: "/devices",
  unlinkDevice: "unlinkdevice",
  addDevice: "/devices/adddevice",
  linkDevice: "linkdevice",
  loginsDetailsPage: "/logins-details",
  feedbackPage: "/feedback",
  resetPasswordPage: "/reset-password",
  errorPage: "/errorPage",
  addhHospitalPage: "/add-hospital",
  productActivationPage: "/product-activation",
  hospitalOnboardPage: "/hospital-onboard",
  personalInfoPage: "/personal-info",
  rolesAuthoritiesPage: "/roles-authorities",
  misDepartment: "/mis/departments",
  misDiagnosis: "/mis/diagnosis",
  MisGraphs: "/mis/graphs",
  userProfilePage: "/profile",
  profilePasswordReset: "/profilepasswordreset",
  editdevice: "editdevice",
  alldevice: "alldevice",
};

export default routesName;
